import { TranslocoDirective, provideTranslocoScope } from '@jsverse/transloco';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  providers: [provideTranslocoScope('tasks')],
  selector: 'task-product-delete-confirm-dialog',
  imports: [MatButtonModule, MatDialogModule, TranslocoDirective],
  templateUrl: './task-product-delete-confirm-dialog.html',
  styleUrl: './task-product-delete-confirm-dialog.scss',
})
export class TaskProductDeleteConfirmDialog {}
